import { apiService } from './api';

export type PaymentGWPayload = {
  version: string;
  merchantId: string;
  terminalId: string;
  totalAmount: number;
  currency: number;
  locale: string;
  purchaseTime: string;
  orderId: string;
  delay: number;
  signature: string;
};

export type PaymentOrderResponse = {
  orderId: string;
  amount: number;
  tokens: number;
  productId: string;
};

export const createPaymentOrder = async (productId: string): Promise<PaymentOrderResponse> => {
  return apiService.createPaymentOrder(productId);
};

export const buildPaymentPayload = async (orderId: string): Promise<PaymentGWPayload> => {
  return apiService.buildPaymentPayload(orderId);
};

